import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Progress } from 'antd';
import { priceFormatter } from 'common/helpers/formatter.helper';
import { PERCENT_100, PROGRESS_STEP_WIDTH_PX, PROGRESS_STEPS_DEFAULT_VALUE } from 'common/config';
import { getBasketGeneralInformation, getBasketProgressColor } from 'entities/Basket/Basket.helper';
import { IBasket, IBasketGoods } from 'entities/Basket/Basket.models';

interface IComponentProps {
  basket: IBasket | null;
  selectedGoods: IBasketGoods[];
}

export const BasketProgress: FC<IComponentProps> = ({ basket, selectedGoods }) => {
  const [steps, setSteps] = useState<number>(PROGRESS_STEPS_DEFAULT_VALUE);
  const ref = useRef<HTMLDivElement | null>(null);
  const { amount, availableAmount, isLimitExceeded } = useMemo(() => {
    return getBasketGeneralInformation({ goods: selectedGoods, basket });
  }, [selectedGoods, basket]);

  const availableLimit = basket?.availableLimit ?? 0;
  const percent = Math.round((amount * PERCENT_100) / availableLimit);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setSteps(Math.round(entry.contentRect.width / PROGRESS_STEP_WIDTH_PX));
      }
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className="redesign absolute py-11 basket-progress">
      <div className="mb-4 flex align-center justify-between">
        <span className="ff-medium fs-m">Доступные средства</span>

        {isLimitExceeded ? (
          <span className="ff-medium fs-m color-red">{`Лимит превышен на ${priceFormatter(Math.abs(availableAmount))}`}</span>
        ) : (
          <span className="ff-medium fs-m">{priceFormatter(availableAmount)}</span>
        )}
      </div>

      <Progress className="mb-3" showInfo={false} percent={percent} steps={steps} strokeColor={getBasketProgressColor(percent)} />

      <div className="flex align-center justify-between">
        <span className="ff-regular fs-xs color-dark-grey">{`${priceFormatter(amount)} сумма заказа`}</span>

        <span className="ff-regular fs-xs color-dark-grey">{`лимит на закупку ${priceFormatter(availableLimit)}`}</span>
      </div>
    </div>
  );
};
